/** Idle session poll: keep chat typing smooth; full SessionView is large. */
export const SESSION_POLL_IDLE_MS = 8_000;

/** Busy session poll: still feel live for thinking / assistant progress. */
export const SESSION_POLL_BUSY_MS = 1_500;

export function sessionPollDelayMs(agentBusy: boolean): number {
  return agentBusy ? SESSION_POLL_BUSY_MS : SESSION_POLL_IDLE_MS;
}
